import { render } from "./TeamCarriers.vue?vue&type=template&id=76a8c3b9&scoped=true"
import script from "./TeamCarriers.vue?vue&type=script&lang=js"
export * from "./TeamCarriers.vue?vue&type=script&lang=js"

import "./TeamCarriers.vue?vue&type=style&index=0&id=76a8c3b9&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a8c3b9"]])

export default __exports__